import { fAlertToast } from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import { common_WMStransDetailAttributes_GETROW } from "../../Server/ApiV2";
// import { fExecuteAPI } from "../../Server/Apis.jsx";
import { fcheck_null_undefine_replace_empty } from "./../../Utility/Utilitys";
import { common_ItemsSearchReport_GETROW } from "./../../Server/ApiV2";
import { fExecuteAPI } from "./../../Server/Apis";

export const sWebTransDetailReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebTransDetailReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];

export const sWebBetweenReportArr = [{ Uid: "Between", Value: "Btwn" }];

export const HeadObjectInit = {
  sItem: "All",
  sDate: sWebBetweenReportArr[0].Uid,
  sLocation: "Is",
  sDocNo: "All",
  sParty: "All",
  sCluster: "All",
  sTransaction: "All",
  sDocType: "All",
  sFromDate: new Date(),
  sToDate: new Date(),
  sDocNo_Input: "",
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sPartyArr: [],
  sPartyPrnt: "",
  sPartyCode: "",
  sPartyName: "",
  sClusterArr: [],
  sClusterPrnt: "",
  sClusterCode: "",
  sClusterName: "",

  sTransactionArr: [],
  sTransactionPrnt: "",
  sTransactionCode: "",
  sTransactionName: "",

  sDocTypeArr: [],
  sDocTypePrnt: "",
  sDocTypeCode: "",
  sDocTypeName: "",
  sItemName: "",
  sItemCode: "",
};

export const DetailReporteData = [];
export const AnalysisReporteData = [];
export const ComparisionReporteData = [];

export const GetWmsStockRepotParty = async (setGroupData) => {
  // const CurrentMaingroupArr = await common_PartyListReport_GETROW("");
  // if (CurrentMaingroupArr?.status === 200) {
  //   setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  // }
};

export const GetWMSMISAttributes = async (
  setTransactionData,
  setPartyData,
  setClusterData,
  setDocTypeData,
  setLocationData
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var userCodeObj = {
    userCd: vRdxUserInfoObj.UserID,
  };
  const vResult = await common_WMStransDetailAttributes_GETROW(userCodeObj);
  if (vResult?.status === 200) {
    setTransactionData(vResult?.data?.ResultSet?.transtype);
    setPartyData(vResult?.data?.ResultSet?.party);
    setClusterData(vResult?.data?.ResultSet?.cluster);
    setDocTypeData(vResult?.data?.ResultSet?.doctypes);
    setLocationData(vResult?.data?.ResultSet?.loc);
  }
};

export const fValidationHead_Client = (HeadObject) => {
  let iRes = true;

  if (
    HeadObject.sFromDate === "" ||
    HeadObject.sFromDate === null ||
    HeadObject.sFromDate === undefined ||
    HeadObject.sFromDate === "Invalid Date" ||
    HeadObject.sToDate === "" ||
    HeadObject.sToDate === null ||
    HeadObject.sToDate === undefined ||
    HeadObject.sToDate === "Invalid Date"
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sParty.toUpperCase() === "IS" &&
    HeadObject.sPartyPrnt === ""
  ) {
    fAlertToast("FAILED", "sParty should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sDocType.toUpperCase() === "IS" &&
    HeadObject.sDocTypePrnt === ""
  ) {
    fAlertToast("FAILED", "sDocType should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sTransaction.toUpperCase() === "IS" &&
    HeadObject.sTransactionPrnt === ""
  ) {
    fAlertToast("FAILED", "sTransaction should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sCluster.toUpperCase() === "IS" &&
    HeadObject.sClusterPrnt === ""
  ) {
    fAlertToast("FAILED", "sCluster should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sDocNo.toUpperCase() === "IS" &&
    HeadObject.sDocNo_Input === ""
  ) {
    fAlertToast("FAILED", "Docment Number should not be empty");

    iRes = false;
    return iRes;
  }
  if (HeadObject.sItem.toUpperCase() === "IS" && HeadObject.sItemCode === "") {
    fAlertToast("FAILED", "ItemCode should not be empty");
    iRes = false;
    return iRes;
  }
  if (HeadObject.sItem.toUpperCase() === "IS" && HeadObject.sItemName === "") {
    fAlertToast("FAILED", "ItemName should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }

  return iRes;
};
export const fValidationDetail_Client = (sBufferObj, HeadObject) => {
  let iRes = true;
  if (
    sBufferObj.sDetailReportRadioBtnName === "" ||
    sBufferObj.sDetailReportRadioBtnName === null ||
    sBufferObj.sDetailReportRadioBtnName === undefined
  ) {
    fAlertToast("FAILED", "DetailReport should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};
export const GetSearchItem = async (xData, xType, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: "", //by sir
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await common_ItemsSearchReport_GETROW(FinalObj);
  if (vItemSearch?.status === 200) {
    let vItemSearchArr = vItemSearch?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
export const GetItemFullSearchArr = async (xItemName) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: "", //by sir
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};
